import React from 'react';
import { INITIAL_DECKS } from '../../hooks/useYonotsune.js';
import { getUILoc } from '../../utils/cardUtils.js';

const YonotsuneRecordsModal = ({ records, onClose }) => {
  const totalRuns = records?.totalRuns || 0;
  const clearsByMemory = records?.clearsByMemory || {};
  const phaseLossCounts = records?.phaseLossCounts || {};
  const maxBreakoutVictories = records?.maxBreakoutVictories || 0;

  // 最多途絶フェーズの計算
  let maxLossPhase = null;
  let maxLossCount = 0;

  Object.entries(phaseLossCounts).forEach(([phase, count]) => {
    if (count > maxLossCount) {
      maxLossCount = count;
      maxLossPhase = phase;
    }
  });

  const maxLossPhaseText = maxLossPhase 
    ? (getUILoc('YONOTSUNE.RECORDS.MAX_LOSS_PHASE_FMT', { phase: maxLossPhase, count: maxLossCount }) || `フェーズ ${maxLossPhase} (${maxLossCount}回)`)
    : (getUILoc('YONOTSUNE.RECORDS.NONE') || 'なし');

  return (
    <div className="player-details-overlay pile-detail-overlay" style={{ zIndex: 20000 }} onClick={onClose}>
      <div className="player-details-modal pile-detail-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '650px', width: '92%' }}>
        <div className="player-details-header">
          <h3>{getUILoc('YONOTSUNE.RECORDS.TITLE') || '検証記録'}</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="player-details-content" style={{ padding: '15px 10px' }}>
          <div className="records-summary-grid" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            
            {/* 挑戦回数 */}
            <div className="record-card" style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid var(--color-border)', borderRadius: '6px', padding: '14px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'var(--color-text-main)', fontSize: '1.05rem', fontWeight: 'bold' }}>
                {getUILoc('YONOTSUNE.RECORDS.TOTAL_RUNS') || '世の常 挑戦回数'}
              </span>
              <span style={{ color: 'var(--color-accent)', fontSize: '1.3rem', fontWeight: 'bold', fontFamily: 'monospace' }}>
                {totalRuns} {getUILoc('UNITS.TIMES') || '回'}
              </span>
            </div>

            {/* 各記憶のクリア回数 */}
            <div className="record-card" style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid var(--color-border)', borderRadius: '6px', padding: '14px 20px' }}>
              <div style={{ color: 'var(--color-text-main)', fontSize: '1.05rem', fontWeight: 'bold', marginBottom: '10px' }}>
                {getUILoc('YONOTSUNE.RECORDS.MEMORY_CLEARS_TITLE') || '各記憶のクリア回数'}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '10px' }}>
                {Object.entries(INITIAL_DECKS).map(([deckKey, config]) => {
                  const clearCount = clearsByMemory[deckKey] || 0;
                  return (
                    <div key={deckKey} style={{ background: 'rgba(0, 0, 0, 0.4)', border: '1px solid var(--color-border)', borderRadius: '4px', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <span style={{ fontSize: '0.9rem', color: 'var(--color-text-dim)' }}>
                        {getUILoc(config.nameKey)}
                      </span>
                      <span style={{ fontSize: '1.15rem', color: '#adff2f', fontWeight: 'bold', fontFamily: 'monospace' }}>
                        {clearCount} {getUILoc('UNITS.TIMES') || '回'}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* 最多途絶フェーズ */}
            <div className="record-card" style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid var(--color-border)', borderRadius: '6px', padding: '14px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'var(--color-text-main)', fontSize: '1.05rem', fontWeight: 'bold' }}>
                {getUILoc('YONOTSUNE.RECORDS.MOST_FAILED_PHASE') || '途絶率最多フェーズ'}
              </span>
              <span style={{ color: '#ff9900', fontSize: '1.2rem', fontWeight: 'bold', fontFamily: 'monospace' }}>
                {maxLossPhaseText}
              </span>
            </div>

            {/* 外交交渉決裂戦 最多勝利数 */}
            <div className="record-card" style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid var(--color-border)', borderRadius: '6px', padding: '14px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'var(--color-text-main)', fontSize: '1.05rem', fontWeight: 'bold' }}>
                {getUILoc('YONOTSUNE.RECORDS.MAX_BREAKOUT_VICTORIES') || '1プレイでの外交交渉決裂戦 最多勝利数'}
              </span>
              <span style={{ color: '#00f0ff', fontSize: '1.2rem', fontWeight: 'bold', fontFamily: 'monospace' }}>
                {maxBreakoutVictories} {getUILoc('UNITS.VICTORIES') || '勝'}
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default YonotsuneRecordsModal;
